import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAdmin } from '../hooks/useAdmin';
import { CircularProgress } from '@material-ui/core';

const AdminRoute = ({ component: Component, ...rest }) => {
  const { isAdmin, loading } = useAdmin();

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Route
      {...rest}
      render={props =>
        isAdmin ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default AdminRoute;